const TeamCards = (props) => {
  return (
    // <div className="py-10 grid">
    //   <div className="rounded-md p-[2px] bg-gradient-to-r from-accent via-[#1C8D8E] to-[#2A5E6F] hover:scale-105 duration-200 background-animate relative">
    //     <span className="block text-m text-white rounded-md bg-bg-primary object-fill relative p-5 h-full">
    //       <img
    //         src={props.url}
    //         className="w-[100px] h-[120px] object-fill rounded-md relative left-[50%] -translate-x-1/2 -top-16 "
    //         alt="img"
    //       ></img>
    //       <h1 className="Text">{props.position}</h1>
    //       <p className="text-center">{props.text}</p>
    //       <div className="flex justify-center items-center gap-x-2 mt-3">
    //         <a href={props.fb}>
    //           <img src={Fb} className="h-8 w-8" alt="fb" />
    //         </a>
    //       </div>
    //     </span>
    //   </div>
    // </div>
    <div className="p-8 my-10 border-2 border-accent rounded-xl flex flex-col gap-y-5">
      <div className="flex justify-center items-center">
        <img
          src={props.url}
          alt="founders"
          height="100px"
          width="100px"
          className="rounded-full overflow-hidden"
        />
      </div>
      <div>
        <h1 className="font-bold text-center text-transparent bg-clip-text bg-gradient-to-r from-accent via-[#1C8D8E] to-[#2A5E6F]">
          {props.name}
        </h1>
        <h1 className="font-bold text-center text-transparent bg-clip-text bg-gradient-to-r from-[#31edf0] via-[#1C8D8E] to-[#46d961] background-animate">
          {props.position}
        </h1>
      </div>
      <div className="px-12">
        <p className="text-[#a7a7a7] text-justify">{props.experience}</p>
      </div>
      <p className="text-center">{props.text}</p>
      {/* <div className="w-full flex flex-col justify-center items-center">
        <a href={props.fblink}>
          <img src={Fb} alt="fb" className="w-10 h-10" />
        </a>
      </div> */}
    </div>
  );
};

export default TeamCards;
